export default __webpack_public_path__ + "static/media/kitchen3-afterJ.0f96c2ea.jpg";